// Presentation only. Never use this selection for persistence or fiscal payloads.
function primeiroPreco(valores) {
  for (const valor of valores) {
    if (valor === null || valor === undefined || (typeof valor === 'string' && !valor.trim())) continue;
    const numero = Number(valor);
    return Number.isFinite(numero) ? numero : null;
  }
  return null;
}

export function ehValorDeCusto(tipoPedido, doacao = false) {
  return doacao || String(tipoPedido || '').trim().toUpperCase() === 'WD';
}

export function precoVisualizacao({ item = {}, resposta = null, tipoPedido = '', assessment = false, doacao = false } = {}) {
  const tipo = String(tipoPedido || resposta?._tipoPedido || '').trim().toUpperCase();
  const doacaoSelecionada = doacao || tipo === 'WD' || resposta?._pedidoDoacao === true;
  const comercial = [
    item.precoComImposto, item.pedido_item_preco_unitario, item.precoUnitario,
    item.item_price_exibicao, item.item_price, item.preco_unitario,
  ];
  if (doacaoSelecionada) {
    return primeiroPreco([
      resposta?.raw?.PrecoDoacao, resposta?.precoDoacao,
      item.precoDoacaoErp, item.pedido_item_preco_doacao_erp, item.preco_doacao_erp,
      // Existing-order API exposes the persisted snapshot under these names.
      // For WD the same storage column holds the donation price, not table/net.
      item.pedidoItemPrecoTabela, item.pedidoitemprecotabela,
      item.precoDoacao, item.precoComImposto, item.pedido_item_preco_unitario,
      item.precoUnitario, item.item_price_exibicao, item.preco_unitario,
    ]);
  }
  const tabelaSelecionada = tipo === 'WC' || assessment === true
    || resposta?.assessmentFlag === true || item.assessmentFlag === true;
  if (tipo === 'WS' || tabelaSelecionada) {
    const tabela = primeiroPreco([
      resposta && !resposta._erro ? resposta.raw?.PrecoTabela : null,
      resposta && !resposta._erro ? resposta.precoComImposto : null,
      item.precoTabelaErp, item.pedido_item_preco_tabela_erp, item.preco_tabela_erp,
      item.pedidoItemPrecoTabela, item.pedidoitemprecotabela,
    ]);
    // A WS commercial/net price is never a substitute for a missing ERP table snapshot.
    if (tabela !== null || tipo === 'WS') return tabela;
    return primeiroPreco(comercial);
  }
  return primeiroPreco([
    resposta?.raw?.PrecoLiquido, resposta?.valorComDesconto, ...comercial,
  ]);
}